/* eslint-disable no-restricted-syntax */
import { getPluginOptions } from '@udecode/plate';

import { getFileData } from 'utils/images';
import { uploadEditorImageToS3 } from 'services/amazon';
import { KEY_DOCUMENT_SETTINGS } from '../../document-settings/createDocumentSettingsPlugin';

export const uploadFile = async (editor, file) => {
  let status;
  let filename;

  const [header, b64] = await getFileData(file, 12);
  file.url = b64;

  const { imageUploadPath } = getPluginOptions(editor, KEY_DOCUMENT_SETTINGS);

  const dataUrl = await uploadEditorImageToS3(
    file,
    header,
    imageUploadPath,
    (value, error) => {
      status = value;
      let errMsg = typeof error === 'string' ? error : 'Something went wrong. Please try again.';

      if (error instanceof Error && error.message) {
        errMsg = error.message;
      }

      if (value === 'failed') {
        editor.cloud.imageFileHandlers?.onError?.(filename, errMsg);
      }
    },
    (uploadFilename) => {
      filename = uploadFilename;
      editor.cloud.imageFileHandlers?.onStart?.(file, uploadFilename);
    },
    (percent) => {
      editor.cloud.imageFileHandlers?.onProgress?.(filename, percent);
    },
  );

  if (status === 'success') {
    editor.cloud.imageFileHandlers?.onSuccess?.(file, filename, dataUrl);
  }
};

export const uploadFiles = (editor, files) => {
  for (const file of files) {
    uploadFile(editor, file);
  }
};
